export default "__VITE_ASSET__Dxyvv4Kp__"